
const GROUP = {
    OVERVIEW: 'overview',
    REPORT: 'report',
    WORKSPACE: 'workspace'
}

const hasFlag = (client, flag) => !!client?.featureFlags?.includes(flag)

const REPORTS = [
    {
        id: 'Overview',
        label: 'Overview',
        slug: 'overview',
        group: GROUP.OVERVIEW,
        summaryKey: null,
        isVisible: ({ client }) => !client?.hideDecisioning
    },
    {
        id: 'FMCSA',
        label: 'FMCSA',
        slug: 'fmcsa',
        group: GROUP.REPORT,
        summaryKey: 'FMCSA',
        isVisible: ({ client }) => !client?.hideFmcsa
    },
    {
        id: 'Motus',
        label: 'MOTUS',
        slug: 'motus',
        group: GROUP.REPORT,
        summaryKey: 'MOTUS',
        isVisible: ({ client }) => hasFlag(client, 'MOTUS')
    },
    {
        id: 'SOS',
        label: 'SOS',
        slug: 'sos',
        group: GROUP.REPORT,
        summaryKey: 'SOS'
    },
    {
        id: 'TinVerification',
        label: 'TIN',
        slug: 'tin',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ client }) => hasFlag(client, 'TIN_VERIFICATION')
    },
    {
        id: 'Verification',
        label: 'Verification',
        slug: 'verification',
        group: GROUP.REPORT,
        summaryKey: 'LEXIS_VERIFICATION',
        isVisible: ({ client }) => !client?.hideVerification
    },
    {
        id: 'Background',
        label: 'Background',
        slug: 'bgv',
        group: GROUP.REPORT,
        summaryKey: 'LEXIS_BACKGROUND'
    },
    {
        id: 'UCC',
        label: 'UCC',
        slug: 'ucc',
        group: GROUP.REPORT,
        summaryKey: 'UCC',
        isVisible: ({ client }) => !client?.newUccEnabled
    },
    {
        id: 'New UCC',
        label: 'UCC',
        slug: 'ucc',
        group: GROUP.REPORT,
        summaryKey: 'UCC',
        isVisible: ({ client }) => !!client?.newUccEnabled
    },
    {
        id: 'Credit Check',
        label: 'Credit Check',
        slug: 'creditcheck',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ client, isDemoMode }) => !client?.hideCreditCheck && !isDemoMode
    },
    {
        id: 'AR Balance',
        label: 'AR Balance',
        slug: 'arbalance',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ client }) => !!client?.arBalanceEnabled
    },
    {
        id: 'Bank Transactions',
        label: 'Bank Transactions',
        slug: 'transactions',
        group: GROUP.REPORT,
        summaryKey: 'PLAID_ASSETS',
        isVisible: ({ client }) => !client?.hideBankTransactions
    },
    {
        id: 'Balance Sheet',
        label: 'Balance Sheet',
        slug: 'balancesheet',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ balanceSheetAnalysis }) => !!balanceSheetAnalysis
    },
    {
        id: 'Income Statement',
        label: 'Income Statement',
        slug: 'incomestatement',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ incomeStatementAnalysis }) => !!incomeStatementAnalysis
    },
    {
        id: 'Cash Flow',
        label: 'Cash Flow',
        slug: 'cashflow',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ cashFlowStatementAnalysis }) => !!cashFlowStatementAnalysis
    },
    {
        id: 'DSCR',
        label: 'DSCR',
        slug: 'dscr',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ dscrAnalysis }) => !!dscrAnalysis
    },
    {
        id: 'Taxes',
        label: 'Taxes',
        slug: 'taxes',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ taxrockEnabled }) => !!taxrockEnabled
    },
    {
        id: 'Terms',
        label: 'Terms',
        slug: 'terms',
        group: GROUP.WORKSPACE,
        summaryKey: null,
        isVisible: ({ hasDocusignEnabled }) => !!hasDocusignEnabled
    },
    {
        id: 'Credit Memo',
        label: 'Credit Memo',
        slug: 'creditmemo',
        group: GROUP.WORKSPACE,
        summaryKey: null
    },
    {
        id: 'Messages',
        label: 'Messages',
        slug: 'messages',
        group: GROUP.WORKSPACE,
        summaryKey: null,
        isVisible: ({ hasClientPortal, draftApplication }) => !!hasClientPortal && !!draftApplication
    },
    {
        id: 'Notes',
        label: 'Notes',
        slug: 'notes',
        group: GROUP.WORKSPACE,
        summaryKey: null
    },
    {
        id: 'Reputational Report',
        label: 'Reputational Report',
        slug: 'reputationalreport',
        group: GROUP.REPORT,
        summaryKey: null
    },
    {
        id: 'Attachments',
        label: 'Attachments',
        slug: 'attachments',
        group: GROUP.WORKSPACE,
        summaryKey: null
    },
    {
        id: 'Tasks',
        label: 'Tasks',
        slug: 'tasks',
        group: GROUP.WORKSPACE,
        summaryKey: null,
        isVisible: ({ client }) => !!client?.activityDashboardEnabled
    },
    // When HEALTHCARE_SEARCH is on, the standalone SAM.gov / NPPES / LEIE tabs fold into
    // the unified Healthcare Search tab — hide them individually so the applicant surface
    // matches the QuickSearch layout.
    {
        id: 'SAM.gov',
        label: 'SAM.gov',
        slug: 'samgov',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ client }) => hasFlag(client, 'SAMGOV') && !hasFlag(client, 'HEALTHCARE_SEARCH')
    },
    {
        id: 'NPPES',
        label: 'NPPES',
        slug: 'nppes',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ client }) => hasFlag(client, 'NPPES') && !hasFlag(client, 'HEALTHCARE_SEARCH')
    },
    {
        id: 'LEIE',
        label: 'LEIE',
        slug: 'leie',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ client }) => hasFlag(client, 'LEIE') && !hasFlag(client, 'HEALTHCARE_SEARCH')
    },
    {
        id: 'STATE_MEDICAID',
        label: 'State Medicaid',
        slug: 'state-medicaid',
        group: GROUP.REPORT,
        summaryKey: null,
        // Healthcare Search now includes the state Medicaid lists, so the standalone tab only
        // remains for clients that have State Medicaid without Healthcare Search (as with LEIE).
        isVisible: ({ client }) => hasFlag(client, 'STATE_MEDICAID') && !hasFlag(client, 'HEALTHCARE_SEARCH')
    },
    {
        id: 'HEALTHCARE_SEARCH',
        label: 'Healthcare Search',
        slug: 'healthcare-search',
        group: GROUP.REPORT,
        summaryKey: null,
        isVisible: ({ client }) => hasFlag(client, 'HEALTHCARE_SEARCH')
    }
]

const BROKER_HIDDEN_IDS = [
    'FMCSA', 'SOS', 'Verification', 'Background', 'UCC', 'New UCC', 'Credit Check',
    'AR Balance', 'Bank Transactions', 'Balance Sheet', 'Income Statement', 'Taxes', 'Terms', 'Credit Memo', 'Messages',
    'Reputational Report', 'Attachments', 'Tasks', 'TinVerification', 'Motus'
]

const getVisibleReports = (context = {}) => {
    if (context.isBrokerCustomer) {
        return REPORTS.filter(report => !BROKER_HIDDEN_IDS.includes(report.id))
    }
    return REPORTS.filter(report => (report.isVisible ? report.isVisible(context) : true))
}

const findReportBySlug = (reports, slug) => reports.find(report => report.slug === slug)

const findReportById = (reports, id) => reports.find(report => report.id === id)

const resolveReport = (reports, id) => {
    const visible = findReportById(reports, id)
    if (visible) return visible

    const requested = REPORTS.find(report => report.id === id)
    return requested ? findReportBySlug(reports, requested.slug) : undefined
}

const getReportIdByType = (reportType) => {
    const match = REPORTS.find(report => report.summaryKey && report.summaryKey === reportType)
    return match ? match.id : 'Overview'
}

const getSourceLabel = (reportType) => {
    const match = REPORTS.find(report => report.summaryKey && report.summaryKey === reportType)
    return match ? match.label : String(reportType || '').replace(/_/g, ' ')
}

export {
    GROUP,
    REPORTS,
    BROKER_HIDDEN_IDS,
    getVisibleReports,
    findReportBySlug,
    findReportById,
    resolveReport,
    getReportIdByType,
    getSourceLabel
}
